<div class="version-dropdown" (click)="onOutsideClick($event)">
  <div class="dropdown-header" (click)="toggleDropdown()">
    <div class="selected-value" [class.placeholder]="!selectedValue">
      {{ selectedDisplayText() }}
    </div>
    <div class="dropdown-arrow" [class.open]="isOpen">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M7 10l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>

  <div class="dropdown-content" [class.open]="isOpen" *ngIf="isOpen">
    <div class="version-list">
      <div
        class="version-item"
        *ngFor="let version of contentList; trackBy: trackByRecordId"
        (click)="selectItem(version)"
        [class.selected]="selectedValue?.record_id === version.record_id">

        <!-- Debug info -->
        <!-- <div style="font-size: 10px; color: #999; margin-bottom: 8px;">
          Debug: {{ version | json }}
        </div> -->

        <!-- Version Title and Status on same line -->
        <div class="version-title">
          <span>{{ getVersionDisplayText(version) }}</span>
          <div class="version-status" *ngIf="getStatusTag(version)">
            <div class="status-tag">
              <img src="assets/icons/playground/published_status.svg" alt="published" class="status-icon">
              <span>{{ getStatusTag(version)?.text }}</span>
            </div>
          </div>
        </div>

        <!-- Timestamp with clock icon -->
        <div class="version-timestamp">
          <img src="assets/icons/playground/access_time.svg" alt="time" class="timestamp-icon">
          <span *ngIf="getTimestamp(version); else noTimestamp">{{ getTimestamp(version) | utcDateTime }}</span>
          <ng-template #noTimestamp>
            <span>No timestamp</span>
          </ng-template>
        </div>

        <!-- Author with person icon -->
        <div class="version-author">
          <img src="assets/icons/playground/person.svg" alt="person" class="author-icon">
          <span>by {{ getAuthor(version) || 'Unknown' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
